import {
  Building,
  Shield,
  Heart,
  GraduationCap,
  Store,
  Factory,
  Briefcase,
  Users,
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import businessPartnership from "@/assets/business-partnership.jpg";
import { title } from "process";

const Industries = () => {
  const sectors = [
    {
      title: "Corporate Organizations",
      icon: Building,
      description:
        "Private sector companies across all industries seeking operational excellence and leadership development.",
      industries: [
        "Private sector companies across all industries",
        "Multinational corporations and local subsidiaries",
        "Family-owned businesses and cooperatives",
        "Manufacturing, services, technology, and finance",
      ],
      color: "bg-blue-500",
      focus:
        "Operational Efficiency, Employee Management and Welfare, Private Company Policy Alignment",
    },
    {
      title: "Government & Public Sector",
      icon: Users,
      description:
        "Government agencies and public institutions working to improve service delivery and operational efficiency.",
      industries: [
        "Government agencies and ministries",
        "Parastatals and state corporations",
        "County governments and local authorities",
        "Public service organizations",
      ],
      color: "bg-green-500",
      focus:
        "Capacity Building, Impact Delivery, and Operational Excellence,Humanity and Sustainability, Service to the People, For the People and By the People",
    },
    {
      title: "Non-Governmental Organizations",
      icon: Heart,
      description:
        "Development agencies and community organizations focused on capacity building and impact delivery.",
      industries: [
        "International and local NGOs",
        "Community-based organizations",
        "Faith-based organizations",
        "Development agencies",
      ],
      color: "bg-red-500",
      focus:
        "Capacity Building, Impact Delivery, and Operational Excellence,Humanity and Sustainability",
    },
    {
      title: "Educational Institutions",
      icon: GraduationCap,
      description:
        "Academic institutions seeking to enhance administrative efficiency and educational leadership.",
      industries: [
        "Universities and colleges",
        "Secondary schools and academies",
        "Training institutes",
        "Professional associations",
      ],
      color: "bg-purple-500",
      focus:
        "Educational Efficiency, Transformation and Skill and Talent, Leadership Development, and Innovation",
    },
    {
      title: "Small & Medium Enterprises",
      icon: Factory,
      description: "Tailored programs for growing businesses and entrepreneurs",
      industries: [
        "Startups and entrepreneurs",
        "Professional service firms",
        "Retail and hospitality businesses",
        "Manufacturing SMEs",
      ],
      color: "bg-orange-500",
      focus:
        "Success of small and medium enterprises, Stock Flow and Growth of SMEs",
    },
    {
      title: "Healthcare Organizations",
      icon: Heart,
      description:
        "Healthcare providers focused on patient care excellence and operational improvement.",
      industries: [
        "Hospitals and medical centers",
        "Healthcare networks",
        "Medical associations",
        "Public health organizations",
      ],
      color: "bg-pink-500",
      focus:
        "Patient-centered care, quality improvement, healthcare management, and compliance",
    },
    {
      title: "Professional Services",
      icon: Briefcase,
      description: "Specialized training for service-oriented organizations",
      industries: [
        "Legal and consulting firms",
        "Healthcare organizations",
        "Financial services",
        "Technology companies",
      ],
      color: "bg-indigo-500",
      focus:
        "Business development, operational efficiency, team building, and growth management",
    },
    {
      title:"InterGovernmental Organizations",
      icon: GraduationCap,
      description: "Leadership development and operational excellence for governments",
      industries: [
        "Government agencies",
        "Public sector organizations",
        "International organizations",
        "Development agencies",
      ],
      color: "bg-yellow-500",
      focus:
        "Leadership development, operational excellence, and governance, and sustainability",
    },
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section
        className="relative pt-20 pb-8 md:pt-20 md:pb-12 bg-gradient-subtle overflow-hidden"
        id="industries"
      >
        <div className="absolute inset-0 bg-gradient-to-r bg-blue-400/95 bg-blue-500/80"></div>
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-40"
          style={{ backgroundImage: `url(${businessPartnership})` }}
        ></div>
        <div className="container mx-auto px-4 relative">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-display font-bold text-4xl md:text-5xl lg:text-6xl mb-6">
              Industries We <span className="text-primary">Serve</span>
            </h1>
            <p className="text-large text-black-400 leading-relaxed max-w-3xl mx-auto">
              As TCLA-X, we are focused on Delivering specialized training
              solutions across diverse sectors throughout Kenya and beyond.
            </p>
          </div>
          <div className="text-center mb-16 py-3">
            <p className="text-xl text-white max-w-3xl mx-auto italic">
              Our comprehensive training programs are designed to meet the
              unique needs of different industries, ensuring relevant and
              impactful learning experiences.
            </p>
          </div>
        </div>
      </section>
      {/* <section className="pt-20 pb-2 bg-gradient-to-r from-primary to-primary text-white>
      <div className="absolute inset-0 bg-gradient-to-r from-background/95 to-background/80"></div>
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
            style={{ backgroundImage: `url(${businessPartnership})` }}
          ></div>
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Industries We Serve
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
            As TCLA-X, we are focused on Delivering specialized training solutions across diverse sectors
            throughout Kenya and beyond.
          </p>
        </div>
        <div className="text-center mb-16 py-3">
          <p className="text-xl text-black max-w-3xl mx-auto italic">
            Our comprehensive training programs are designed to meet the unique
            needs of different industries, ensuring relevant and impactful
            learning experiences.
          </p>
        </div>
      </section> */}

      {/* Sectors Overview */}
      <section className="py-10">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sectors.map((sector, index) => (
              <Card
                key={index}
                className="bg-blue-50 border-5 shadow-2xl hover:shadow-3xl transform hover:scale-[1.02] transition-all duration-300 ease-in-out rounded-6xl h-full"
              >
                <CardContent className="p-8 h-full flex flex-col">
                  <div
                    className={`w-16 h-16 ${sector.color} rounded-lg flex items-center justify-center mx-auto mb-6`}
                  >
                    <sector.icon className="h-8 w-8 text-white" />
                  </div>

                  <h3 className="text-xl font-bold text-center mb-4">
                    {sector.title}
                  </h3>
                  <p className="text-gray-600 text-center mb-6 flex-grow">
                    {sector.description}
                  </p>

                  <div className="space-y-2 mb-6">
                    {sector.industries.map((industry, idx) => (
                      <div key={idx} className="flex items-start">
                        <div className="w-2 h-2 bg-primary rounded-full mt-2 mr-3 flex-shrink-0"></div>
                        <span className="text-sm text-gray-700">
                          {industry}
                        </span>
                      </div>
                    ))}
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground mb-2">
                      Focus Areas:
                    </h4>
                    <p className="text-sm text-muted-foreground">
                      {sector.focus}
                    </p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Industry Success Metrics */}
      <section className="py-16 lg:py-24 bg-gradient-secondary">
        <div className="container mx-auto px-4">
          <div className="text-center space-y-4 mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-foreground">
              Cross-Sector Impact
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Consistent results across all industries we serve, demonstrating
              the adaptability and effectiveness of our training methodologies.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
            <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
              <CardContent className="p-8 space-y-4">
                <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                  <Building className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">150+</div>
                  <h3 className="font-semibold text-foreground">
                    Corporate Clients
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Private sector organizations trained
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
              <CardContent className="p-8 space-y-4">
                <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                  <Shield className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">75+</div>
                  <h3 className="font-semibold text-foreground">
                    Government Agencies
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Public sector partnerships
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
              <CardContent className="p-8 space-y-4">
                <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                  <Heart className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">200+</div>
                  <h3 className="font-semibold text-foreground">NGOs & CBOs</h3>
                  <p className="text-sm text-muted-foreground">
                    Non-profit organizations supported
                  </p>
                </div>
              </CardContent>
            </Card>

            <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
              <CardContent className="p-8 space-y-4">
                <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                  <GraduationCap className="w-8 h-8 text-white" />
                </div>
                <div className="space-y-2">
                  <div className="text-3xl font-bold text-primary">50+</div>
                  <h3 className="font-semibold text-foreground">
                    Educational Institutions
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Schools and universities partnered
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Sector-Specific Solutions */}
      <section className="py-16 lg:py-24 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center space-y-4 mb-12">
              <h2 className="text-3xl font-bold text-foreground">
                Tailored Solutions for Every Sector
              </h2>
              <p className="text-lg text-muted-foreground">
                We understand that each industry has unique challenges,
                regulations, and success metrics.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
                <CardContent className="p-8 space-y-4">
                  <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                    <Factory className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-foreground">
                    Industry-Specific Content
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Training materials and case studies relevant to your
                    sector's challenges and opportunities
                  </p>
                </CardContent>
              </Card>

              <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
                <CardContent className="p-8 space-y-4">
                  <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                    <Shield className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-foreground">
                    Compliance & Standards
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Training programs aligned with industry regulations and
                    professional standards
                  </p>
                </CardContent>
              </Card>

              <Card className="text-center shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out bg-white rounded-xl">
                <CardContent className="p-8 space-y-4">
                  <div className="w-16 h-16 bg-gradient-primary rounded-full flex items-center justify-center mx-auto">
                    <Building className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-lg font-bold text-foreground">
                    Customized Delivery
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    Flexible training formats that work within your industry's
                    operational constraints
                  </p>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 lg:py-24 bg-gradient-primary text-white">
        <div className="container mx-auto px-4 text-center space-y-8">
          <div className="space-y-4">
            <h2 className="text-3xl lg:text-4xl font-bold">
              Elevate Your Industry Standards
            </h2>
            <p className="text-lg text-white/90 max-w-5xl mx-auto">
              Our sector-specific solutions tackle your unique challenges and
              position your organization ahead of the curve.
            </p>
            <p className="text-lg text-white/90 max-w-5xl mx-auto">
              Contact us to discuss how our industry-specific training solutions
              can address your organization's unique challenges.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="secondary" size="lg" asChild>
              <Link to="/contact">Get Industry-Specific Quote</Link>
            </Button>
            
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Industries;
